import { useAtomValue } from "jotai";
import type { ComponentProps } from "react";

import { composablePanelReservedWidthAtom } from "../application/applicationSettingsAtoms";
import { ThumbnailNavigationBar } from "./ThumbnailNavigationBar";

// The thumbnail bar for a composable canvas (activity, frame or interlude). Rendering this — rather
// than a plain ThumbnailNavigationBar — is what marks that a composable canvas is the bar's sibling,
// so it reserves the width the canvas's layers/components/library panel overlays.
export const ComposableCanvasNavigationBar = (
  props: Omit<ComponentProps<typeof ThumbnailNavigationBar>, "reservedStartWidth">,
) => {
  const reservedStartWidth = useAtomValue(composablePanelReservedWidthAtom);
  return <ThumbnailNavigationBar {...props} reservedStartWidth={reservedStartWidth} />;
};
